import axios from "axios";
import { useEffect, useState } from "react";
import { useHotelInfoContext } from "../../../../../components/HotelInfoContext";
import Swal from "sweetalert2";
import { initialData } from "../../const";

export const useGeneralInfo = () => {
  const [initialHotelInfo, setInitialHotelInfo] = useState(null);
  const [hotelInfo, setHotelInfo] = useState(initialData);
  const [message, setMessage] = useState("");

  const { hotelInfo: ctxHotelInfo } = useHotelInfoContext() || {
    hotelInfo: null,
  };

  useEffect(() => {
    // Initialize from provider if available, otherwise keep initialData
    if (ctxHotelInfo) {
      setHotelInfo(ctxHotelInfo);
      setInitialHotelInfo(ctxHotelInfo);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctxHotelInfo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setHotelInfo({ ...hotelInfo, [name]: value });
  };

  const handleRateChange = (value) => {
    setHotelInfo({ ...hotelInfo, starRating: value });
  };

  const handleSocialMediaChange = (e) => {
    const { name, value } = e.target;
    setHotelInfo({
      ...hotelInfo,
      socialMediaLinks: { ...hotelInfo.socialMediaLinks, [name]: value },
    });
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (name === "logo" && files[0] && files[0].type !== "image/png") {
      setMessage("Only PNG files are allowed for the logo.");
      return;
    }
    setHotelInfo({ ...hotelInfo, [name]: files[0] });
  };

  const updateHotelInfo = async () => {
    try {
      const formData = new FormData();
      Object.keys(hotelInfo).forEach((key) => {
        if (key === "socialMediaLinks") {
          Object.keys(hotelInfo[key]).forEach((subKey) => {
            formData.append(
              `socialMediaLinks[${subKey}]`,
              hotelInfo[key][subKey]
            );
          });
        } else {
          formData.append(key, hotelInfo[key]);
        }
      });
      const response = await axios.post("/api/hotelInfo/create", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setHotelInfo(response.data);
      setInitialHotelInfo(response.data);

      Swal.fire({
        title: "Success!",
        text: "Hotel information updated successfully!",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      }).then(() => {
        window.location.href = "/"; // Redirect to Home after upated successfully
      });
    } catch (error) {
      console.error("Error updating hotel info:", error);
      setMessage("Failed to update hotel information.");
    }
  };

  const discardChanges = () => {
    setHotelInfo(initialHotelInfo);
    setMessage("Changes discarded.");
  };

  return {
    hotelInfo,
    updateHotelInfo,
    message,
    discardChanges,
    handleChange,
    handleRateChange,
    handleSocialMediaChange,
    handleFileChange,
  };
};
